// interface transactionStatuses {
//
// }

export default class TransactionStatusesService {
  baseUrl = '/aptitude/api/transactionstatuses';

  constructor(private $http) {
    'ngInject';
  }

  // Will add this interface to the call soon : ng.IPromise<transactionStatuses>
  getTransactionStatuses(parentResourceId: number, cache = false) {
    return this.$http.get(
      `${this.baseUrl}?parentResourceId=${parentResourceId}`,
      { cache }
    );
  }
}
